import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

const IndustryProblem = () => {
  const clientExpectations = [
    'Candidates who communicate well on day one',
    'Faster ramp-up after placement',
    'Consistent training across locations and roles',
    'Reduced early attrition',
    'Proof of readiness—not promises'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Traain for Staffing & Recruiting
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-8">
            <span className="text-cyan-400">Recruiting Doesn't End at Placement Anymore</span>
          </h3>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            In today's market, staffing firms are expected to deliver more than resumes.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <h4 className="text-2xl font-bold text-white mb-6">Clients expect:</h4>
          <div className="space-y-4">
            {clientExpectations.map((expectation, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{expectation}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-lg text-gray-400 italic">
            Traditional onboarding PDFs and ad-hoc prep calls can't keep up.
          </p>
          <p className="text-xl text-white font-semibold">
            Traain gives staffing firms the infrastructure to prepare, validate, and elevate talent—before and after placement.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IndustryProblem;